export default "__VITE_ASSET__B_n8wXyp__"